import { Box, Flex, Link as ChakraLink, Text } from "@chakra-ui/react";
import Link from "next/link";

import { MarkdownRender } from "@/components/MarkdownRender";
import TableOfContent from "@/components/TableOfContent";
import AuthorCard from "@/components/AuthorCard";
import ShareButtons from "@/components/ShareButtons";
import Comments from "@/components/Comments";
import YourOpinion from "@/components/BreedPage/YourOpinion";
import SimilarBehaviors from "@/components/BreedPage/SimilarBehaviors";

export default function Content({ data, authorArticlesTotal, comments, breedRating, similarBehaviors }: any) {

  const similarBehaviorsBySizeBreed = similarBehaviors.filter((item: any) => item.attributes.size === data.data[0].attributes.size);

  return (
    <Box
      as="section"
      flexDirection={{ base: "column", lg: "row" }}
      width="100%"
      paddingBottom={{ base: "0", lg: "80px" }}
      paddingTop="0"
    >
      <Flex
        direction={{ base: "column", lg: "row" }}
        maxWidth="1216px"
        width="90%"
        margin="0 auto"
        p={{ base: "24px 0 24px 0", lg: "0" }}
        gap={{ base: "16px", lg: "32px" }}
      >
        <Flex
          direction="column"
          flex="1 0 0"
          gap="32px"
        >
          <Flex
            p={{ base: "16px", lg: "32px" }}
            direction="column"
            bgColor="#FFF"
            boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)"
            borderRadius="16px"
          >
            <MarkdownRender>
              {data.data[0].attributes.content}
            </MarkdownRender>
            <Flex
              mt="40px"
              mb="40px"
              padding="0 32px 0 32px"
              justifyContent="space-between"
              columnGap="32px"
              rowGap="20px"
              flexDirection={{ base: "column", md: "row" }}
            >
              <Flex
                columnGap="4px"
                alignItems="center"
                flexWrap="wrap"
                rowGap="20px"
              >
                {data.data[0].attributes.tags.data.length > 0 && (
                  <Text
                    marginRight="8px"
                    fontSize="14px"
                    fontWeight="600"
                    color="gray.500"
                  >
                    Tags
                  </Text>
                )}
                {data.data[0].attributes.tags.data &&
                  data.data[0].attributes.tags.data.map(
                    (item: any, i: number) => (
                      <ChakraLink
                        key={i}
                        as={Link}
                        padding="8px 12px"
                        borderRadius="8px"
                        bgColor="gray.100"
                        _hover={{ bgColor: "purple.50" }}
                        color="gray.500"
                        fontWeight="500"
                        fontSize="12px"
                        href={`/blog/tag/${item.attributes.url}`}
                      >
                        #{item.attributes.tag}
                      </ChakraLink>
                    )
                  )}
              </Flex>
              <ShareButtons url={data.data[0].attributes.url} />
            </Flex>
          </Flex>
          <Flex
            direction="column"
            bgColor="#FFF"
            boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)"
            borderRadius="16px"
          >
            <Flex
              p={{ base: "16px 16px 0 16px", lg: "32px 32px 0 32px" }}
              direction="column"
              gap="12px"
            >
              <Text
                fontSize={{ base: "24px", lg: "36px" }}
                lineHeight={{ base: "32px", lg: "40px" }}
                fontWeight="700"
                color="gray.800"
              >
                Perguntas e respostas
              </Text>
              <Text
                fontSize={{ base: "16px", lg: "18px" }}
                lineHeight={{ base: "24px", lg: "28px" }}
                color="gray.500"
              >
                Tire suas dúvidas sobre esta raça com um especialista.
              </Text>
            </Flex>
            <Comments
              isBreed
              id={data.data[0].id}
              item={comments}
            />
          </Flex>
          <YourOpinion breedId={data.data[0].id} ratingData={data.data[0].attributes.rating} breedRating={breedRating} />
          <SimilarBehaviors data={similarBehaviorsBySizeBreed} />
        </Flex>
        <Box
          width={{ base: "100%", md: "387px" }}
          as="aside"
          display="flex"
          flexDir="column"
          rowGap="64px"
          mt={{ base: "40px", lg: "0" }}
        >
          {Array.from(
            data.data[0].attributes.content.matchAll(/^## (.*)$/gm)
          ).length > 0 && (
              <TableOfContent post={data.data[0].attributes.content} />
            )}
          {data.data[0].attributes.content && (
            <AuthorCard authorArticlesTotal={authorArticlesTotal} post={data} />
          )}
        </Box>
      </Flex>
    </Box >
  )
}
